// Contoh teks landing page untuk komunitas partner. Partner mengedit semuanya di tab Landing page.
export const LANDING_EXAMPLE = {
  "hero.badge": "Non-custodial \u00b7 Verified Performance Data \u00b7 Risk-Normalized",
  "hero.title1": "Copy Trade Strategies with",
  "hero.title2": "Verified Risk Data \u2014 Not Promises.",
  "hero.text": "Real performance data pulled directly from your broker account. Risk-normalized position sizing \u2014 you never over-allocate. Your funds stay in your own broker. Always.",
  "hero.quote": "We don\u2019t publish trades. We publish plans.",
  "hero.pill": "Currently: Forex via MT4/MT5",
  "hero.check1": "Non-custodial",
  "hero.check2": "Real drawdown data",
  "hero.check3": "Auto lot sizing",
  "hero.btn1": "Start as Investor",
  "hero.btn2": "I'm a Trader / Analyst",
  "problem.eyebrow": "The Problem With Copy Trading",
  "problem.title": "Most Platforms Show You ROI. We Show You Risk.",
  "problem.intro": "Profitable trader \u2260 safe investment. Most platforms show P&L screenshots \u2014 not real drawdown, not over-leverage, not position sizing risk.",
  "problem.bad1": "Traders over-leverage with no limits",
  "problem.fix1": "Risk-normalized: your position auto-adjusted to your capital",
  "problem.bad2": "You take more risk than you expect",
  "problem.fix2": "25+ risk flags detect unstable behavior automatically",
  "problem.bad3": "No systematic way to evaluate discipline",
  "problem.fix3": "AlphaRank scores consistency + discipline, not just P&L",
  "problem.bad4": "Profitable trader \u2260 safe for your capital",
  "problem.fix4": "Real drawdown from broker \u2014 no screenshots, no hidden losses",
  "solution.eyebrow": "Our Solution",
  "solution.title": "A Risk-Controlled Copy Trading System",
  "solution.t1": "Risk-Normalized Execution",
  "solution.d1": "Trade size is automatically adjusted based on your capital and allocation \u2014 not the trader's lot size.",
  "solution.t2": "Risk Flag Detection",
  "solution.d2": "Over-leverage, no stop loss, and unstable behavior are detected and flagged automatically.",
  "solution.t3": "AlphaRank Scoring",
  "solution.d3": "Traders and analysts ranked by performance, discipline, and consistency \u2014 not hype.",
  "solution.t4": "Transparent Data",
  "solution.d4": "Real trade history, real drawdown, no hidden metrics.",
  "how.eyebrow": "How It Works",
  "how.title": "3 simple steps",
  "how.t1": "Choose Providers",
  "how.d1": "Follow traders or analysts based on AlphaRank, risk level, and track record.",
  "how.t2": "Set Your Allocation",
  "how.d2": "Decide how much capital to allocate. The system handles position sizing automatically.",
  "how.t3": "Copy Automatically",
  "how.d3": "Trades and signals sync automatically by default \u2014 with risk controlled in the background. Prefer manual? You can follow signals that way too.",
  "roles.eyebrow": "Platform",
  "roles.title": "One platform. Three roles.",
  "roles.sub": "Investor, Trader, or Analyst \u2014 the system aligns risk, performance, and incentives for every participant.",
  "roles.inv.head": "For Investors",
  "roles.inv.sub": "Back strategies with controlled risk",
  "roles.inv.b1": "1 broker account \u2014 copy multiple strategies simultaneously",
  "roles.inv.b2": "Funds stay in your own broker \u2014 fully non-custodial",
  "roles.inv.b3": "Choose: copy live trades or subscribe to verified signal plans",
  "roles.tr.head": "For Traders",
  "roles.tr.sub": "Your track record becomes your product",
  "roles.tr.b1": "Connect your MT4/MT5 \u2014 performance syncs automatically",
  "roles.tr.b2": "Get paid based on results, not volume",
  "roles.tr.b3": "Build reputation through AlphaRank\u2122",
  "roles.an.head": "For Analysts",
  "roles.an.sub": "Publish signal plans \u2014 no live account needed",
  "roles.an.b1": "No live trading account required",
  "roles.an.b2": "Followers can auto-copy your signals or follow manually via subscription",
  "roles.an.b3": "Build a verified signal track record",
  "cta.title": "Start Copy Trading with Real Risk Control",
  "cta.text": "Real performance data. Risk-normalized execution. Funds in your own broker \u2014 always.",
  "cta.btn1": "Start as Investor",
  "cta.btn2": "I'm a Trader / Analyst",
};
